import React from 'react';
import PropTypes from 'prop-types';

import Trim from './Trim';
import Packages from './Packages';
import Color from './Color';
import Configuration from './Configuration';
import { getUrlParams } from '../helpers';
/*

make
model
trim 
driveTrain
color
packages
form
confirmation

*/

const QueryComponent = ({ setCurrentStep }) => {
	const searchParams = getUrlParams(window.location.search);
	const { trim, driveTrain, paint } = searchParams;

	let Comp = Trim;
	if (trim && driveTrain && paint) {
		Comp = Packages;
	} else if (trim && driveTrain) {
		Comp = Color;
	} else if (trim) {
		Comp = Configuration;
	}

	return <Comp setCurrentStep={setCurrentStep} />;
};

QueryComponent.propTypes = {
	setCurrentStep: PropTypes.func
};

export default QueryComponent;
